import React from "react";

import { Container } from "@components/Container/Container";

import styles from "./styles.module.scss";
import { Box } from "@components/Box/Box";
import {
  BetterAnswerBox,
  BetterAnswerBoxProps
} from "@components/BetterAnswerBox/BetterAnswerBox";

export interface BetterAnswersListProps {
  Cards: BetterAnswerBoxProps[];
  headline?: string;
  description?: string;
}

const BetterAnswersList: React.FC<BetterAnswersListProps> = ({
  Cards
  // headline,
  // description,
}) => {
  return (
    <Container inside>
      <Box className={styles.gridFour}>
        {Cards &&
          Cards.map((card: BetterAnswerBoxProps) => {
            return (
              <Box key={card.Key}>
                <BetterAnswerBox
                  Question={card.Question}
                  Answer={card.Answer}
                  ShowUrl={true}
                  Url={card.Url}
                />
              </Box>
            );
          })}
      </Box>
    </Container>
  );
};

export { BetterAnswersList };
